/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FreigabeaktionenInputs */

const de__field_freigabeaktionen = /** @type {(inputs: _Field_FreigabeaktionenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freigabeaktionen`)
};

/**

* @param {_Field_FreigabeaktionenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_freigabeaktionen = /** @type {((inputs?: _Field_FreigabeaktionenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FreigabeaktionenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_freigabeaktionen(inputs)
});